import Vue from "vue"
import NavigationWidget from "./NavigationWidget.vue";
import store from "@//apps/NavigationWidget/store/store";

Vue.config.productionTip = false;

let navigationWidgetEle = document.querySelectorAll('widget-navigation');
if (navigationWidgetEle.length) {
    navigationWidgetEle.forEach(el => {
        new Vue({
            el: el,
            store: store,
            render(h) {
                let json = this.$el.attributes.getNamedItem('json');
                let labels = this.$el.attributes.getNamedItem('labels');
                let eventListener = this.$el.attributes.getNamedItem('event-listener');

                return h(NavigationWidget, {
                    props: {
                        json: json ? JSON.parse(json.value) : null,
                        labels: labels ? JSON.parse(labels.value) : null,
                        eventListener: eventListener ? eventListener.value : null
                    }
                })
            }
        });
    });
}
